import { KeyboardEventHandler, ReactNode, useEffect, useMemo } from "react";
import {
  BrandCountText,
  BrandGridContainer,
  Container,
  HeaderSection,
  HeaderSubTitle,
  HeaderTitle,
  ListContainer,
  Tablecontainer,
} from "../style";
import { swipeFilesTabs } from "../../utils/constants";
import AdCard from "../../components/commonComponents/adCard";
import Header from "../../components/header";
import SearchAndFilter from "../../components/searchAndFilter";
import TabsHeader from "../../components/tabsHeader";
import AdTable from "../../components/commonComponents/adTable";
import CreateBoardModal from "../../components/modals/createBoardModal";
import TableToolbar from "../../components/tableToolbar";
import { SwipeFileReducerAction } from "../../store/swipeFile/slice";
import { SwipeFileSagaActions } from "../../store/swipeFile/sagas";
import { useDispatch, useSelector } from "react-redux";
import { InfoOutlined } from "@mui/icons-material";
import {
  selectedTableItemsSelector,
  swipeFileBrandsParamsSelector,
  swipeFileFilterCountsSelector,
  swipeFileListSelector,
  swipeFileLoadingSelector,
  swipeFilePageSearchSelector,
  swipeFileSelectedBoardsSelector,
  swipeFileSelectedTagsSelector,
  swipeFileTabIndexSelector,
  swipeFileTopBrandsSelector,
  swipeFileViewTypeSelector,
  swipeFilesFavouriteBrandFilterSelector,
  swipefileSelectedSortOptionSelector,
} from "../../store/swipeFile/selector";
import { SwipeFileListItems, ViewTypeEnum } from "../../store/swipeFile/types";
import { MetaDataSagaActions } from "../../store/metadata/sagas";
import SaveAdPopover from "../../components/saveAdPopover";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import BrandCard from "../../components/commonComponents/brandCards/brandCard";
import { BoardItem, brandItem, listType } from "../../store/metadata/types";
import CardListWrapper from "../../components/commonComponents/adCard/cardListWrapper";
import TopBrandCarousel from "../../components/commonComponents/brandCards/topBrandCarousel";
import {
  swipeFileSelectedBrandsSelector,
  swipeFileSelectedPlatformsSelector,
} from "../../store/swipeFile/selector";
import InfiniteScroll from "react-infinite-scroll-component";
import FavouriteBrandSwipeFile from "../../components/favouriteBrand/favouriteBrandSwipeFiles";
import { MetaDataReducerAction } from "../../store/metadata/slice";
import DeleteAdModal from "../../components/modals/deleteAdModal";
import AddToBoardModal from "../../components/modals/addToBoardModal";
import AddTagModal from "../../components/modals/addTagModal";
import { useLocation, useNavigate } from "react-router-dom";
import { DiscoverySagaActions } from "../../store/discovery/sagas";
import { activeSubscriptionSelector } from "../../store/payment/selector";
import { theme } from "../../utils/theme";
import { StyledContainedButton } from "../../components/modals/style";
import routeConstant from "../../utils/routeConstant";

const content = {
  tabTitle: "Swipe Ad",
  tabSubTitle: "Your saved FB, Instagram & LinkedIn Ads",
};

const SwipeFiles = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoading = useSelector(swipeFileLoadingSelector);

  const selectedTableItems = useSelector(selectedTableItemsSelector);

  const viewType = useSelector(swipeFileViewTypeSelector);
  const activePlan = useSelector(activeSubscriptionSelector);
  const swipeFileListItems = useSelector(swipeFileListSelector);

  const finalSwipeFileList = activePlan?.isFreePlan
    ? {
        data: swipeFileListItems?.data?.slice(0, 5) || [],
        total: Math.min(swipeFileListItems?.total || 0, 5),
      }
    : swipeFileListItems;

  const swipeFileTopBrandLists = useSelector(swipeFileTopBrandsSelector);

  const userDetails = JSON.parse(localStorage.getItem("User") as string);

  const selectedBrands = useSelector(swipeFileSelectedBrandsSelector);

  const selectedPlatforms = useSelector(swipeFileSelectedPlatformsSelector);

  const selectedBoards = useSelector(swipeFileSelectedBoardsSelector);

  const selectedTags = useSelector(swipeFileSelectedTagsSelector);

  const swipefileSelectedSortOption = useSelector(
    swipefileSelectedSortOptionSelector
  );

  const swipeFileTabIndex = useSelector(swipeFileTabIndexSelector);
  const favouriteBrandFilterEnabled = useSelector(
    swipeFilesFavouriteBrandFilterSelector
  );
  const swipeFileBrandsParams = useSelector(swipeFileBrandsParamsSelector);
  const swipeFileFilterCounts = useSelector(swipeFileFilterCountsSelector);

  const searchValue = useSelector(swipeFilePageSearchSelector);

  const handleViewAdsButtonClicked = (
    brandId: string,
    handleLoadingState: Function
  ) => {
    dispatch(
      SwipeFileSagaActions.fetchBrandSwipeFileItems({
        brandId,
        handleLoadingState,
      })
    );
  };

  const handleViewBrandAds = (brandId: string) => {
    dispatch(
      SwipeFileSagaActions.fetchSelectedBrandSwipeFileItems({
        brandId,
      })
    );
  };

  const handleArchive = (pageId: string, isArchived: boolean) => {
    dispatch(
      DiscoverySagaActions.fetchArchiveAds({
        pageId,
        isArchived: !isArchived,
      })
    );
  };

  const setSwipeFileTabIndex = (tabIndex: number) => {
    dispatch(SwipeFileReducerAction.setSwipeFileTabIndex(tabIndex));
    dispatch(SwipeFileReducerAction.setSelectedTableItemsInitialState([]));
    dispatch(SwipeFileReducerAction.setViewType(ViewTypeEnum.Card));
    dispatch(SwipeFileReducerAction.resetSearchInputValue());

    if (tabIndex === 1) {
      // dispatch(
      //   MetaDataSagaActions.fetchBrandLists({ userId: userDetails?._id })
      // );
      dispatch(
        SwipeFileSagaActions.fetchSwipeFileTopBrandList(swipeFileBrandsParams)
      );
    } else {
      dispatch(SwipeFileReducerAction.resetSwipefileState());
      // dispatch(
      //   SwipeFileSagaActions.fetchSwipeFileList({
      //     userId: userDetails?._id,
      //   })
      // );
    }
  };

  const fetchSortingSwipeFileItems = (
    sortValue: string,
    sortObject: Object
  ) => {
    dispatch(
      SwipeFileReducerAction.setSelectedSortOption({ sortValue, sortObject })
    );
    dispatch(SwipeFileSagaActions.fetchSortedSwipeFileList());
  };

  const fetchfilterSwipeFileItems = (
    selectAll: boolean,
    checked: boolean,
    stateName: string,
    list: listType[],
    id?: string
  ) => {
    dispatch(
      SwipeFileSagaActions.applyFilterOnSwipeFileList({
        selectAll,
        checked,
        id,
        list,
        stateName,
      })
    );
  };

  const refetchSwipeFileItem = (adId: string, updatedBoardList: BoardItem) => {
    dispatch(
      SwipeFileReducerAction.setUpdatedBoardIds({ adId, updatedBoardList })
    );
  };

  const handleClearSwipeFileFilter = () => {
    dispatch(SwipeFileReducerAction.resetSwipefileState());
    dispatch(
      SwipeFileSagaActions.fetchSwipeFileList({
        userId: userDetails?._id,
      })
    );
  };

  useEffect(() => {
    const hasHashParams = location.hash.includes("?");
    const userId = userDetails?._id || userDetails?.user?._id;

    // Fetch swipe file list only if no hash params
    if (!hasHashParams && userId) {
      dispatch(SwipeFileSagaActions.fetchSwipeFileList({ userId }));
    }

    // Always fetch these
    dispatch(MetaDataSagaActions.fetchFavouriteFolderList());
    dispatch(MetaDataSagaActions.fetchFavouriteBrands());
    dispatch(MetaDataSagaActions.fetchBoardList());
    dispatch(MetaDataSagaActions.fetchTagLists());

    // Fetch brand lists if child user id exists
    // if (userId) {
    //   dispatch(MetaDataSagaActions.fetchBrandLists({ userId }));
    // }

    return () => {
      dispatch(SwipeFileReducerAction.resetSwipefileState());
      dispatch(SwipeFileReducerAction.resetSearchInputValue());
      dispatch(MetaDataReducerAction.setBrandFilterSearchText(""));
    };
  }, [dispatch, userDetails?._id, userDetails?.user?._id, location.hash]);

  useEffect(() => {
    if (location.hash.split("?")[1] !== undefined) {
      dispatch(
        SwipeFileSagaActions.fetchSelectedBoardAds({
          boardId: location.hash.split("?")[1],
        })
      );
    }
  }, [dispatch, location.hash]);

  const fetchMoreBrands = () => {
    dispatch(
      SwipeFileSagaActions.fetchSwipeFileTopBrandList({
        ...swipeFileBrandsParams,
        skip: swipeFileBrandsParams.skip + swipeFileBrandsParams.limit,
      })
    );
  };

  const fetchMoreSwipeFileItem = () => {
    dispatch(
      SwipeFileSagaActions.fetchSwipeFileList({
        userId: userDetails?._id,
      })
    );
  };

  const handleSearchChange = (value: string) => {
    dispatch(SwipeFileReducerAction.setSwipeFilePageSearchInputValue(value));
  };

  const handleScrollForSearchBrand = () => {
    window.scrollTo({
      top: 700,
      behavior: "smooth",
    });
  };

  const hanldeSearchButton = () => {
    if (
      swipeFilesTabs[swipeFileTabIndex].id === "my-ads" &&
      location.hash.split("?")[1] === undefined
    ) {
      dispatch(SwipeFileSagaActions.fetchSearchedSwipeFileItema());
    } else if (swipeFilesTabs[swipeFileTabIndex].id === "brands") {
      dispatch(
        SwipeFileSagaActions.fetchSwipeFileSearchTopBrandList({
          handleScroll: handleScrollForSearchBrand,
        })
      );
    }
  };

  const handleSwipeFilesBrandFavouriteFilter = () => {
    dispatch(SwipeFileReducerAction.setSwipeFileTopBrandsToInitialState([]));
    dispatch(
      SwipeFileReducerAction.setSwipeFileFavouriteBrandFilter(
        !favouriteBrandFilterEnabled
      )
    );
    if (!favouriteBrandFilterEnabled) {
      dispatch(
        SwipeFileSagaActions.fetchSwipeFileTopBrandList({
          favourite: !favouriteBrandFilterEnabled,
        })
      );
    } else {
      dispatch(
        SwipeFileSagaActions.fetchSwipeFileTopBrandList({
          ...swipeFileBrandsParams,
          skip: 0,
          favourite: !favouriteBrandFilterEnabled,
        })
      );
    }
  };

  const handleSearchText: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === "Enter") {
      hanldeSearchButton();
    }
  };

  const handleDelete = () => {
    dispatch(SwipeFileSagaActions.deleteAd());
  };

  const handleDeleteMultipleAds = () => {
    dispatch(SwipeFileSagaActions.deleteMultipleAds());
  };
  const RenderAdsComponent = useMemo(() => {
    const swipeFileListItemsLength = finalSwipeFileList?.data?.length ?? 0;
    const hasMoreData = finalSwipeFileList?.total > swipeFileListItemsLength;

    if (!isLoading && swipeFileListItemsLength === 0) {
      return (
        <ListContainer>
          <HeaderTitle textAlign="center">
            {/*Your saved Ads will appear here*/}
            No ads found
          </HeaderTitle>
          <HeaderSubTitle textAlign="center">
            Use our extension to save ads from platforms and grow
          </HeaderSubTitle>
        </ListContainer>
      );
    }
    // @ts-ignore
    return (
      <>
        {swipeFileFilterCounts === 0 && <FavouriteBrandSwipeFile />}
        {viewType === ViewTypeEnum.Card && (
          <ListContainer sx={{ margin: "1rem 0" }}>
            <CardListWrapper>
              {finalSwipeFileList?.data?.map(
                (item: SwipeFileListItems, index: number) => (
                  <AdCard
                    item={item}
                    key={item._id}
                    dataList={finalSwipeFileList?.data}
                    handleViewAd={handleViewBrandAds}
                    locationPathname={location.pathname}
                    handleArchived={handleArchive}
                    ArchiveShow={true}
                  />
                )
              )}
              {(isLoading || hasMoreData) &&
                [...Array(4)]?.map((index) => (
                  <AdCard item={{} as SwipeFileListItems} key={index} />
                ))}
            </CardListWrapper>
            <InfiniteScroll
              scrollableTarget={document.getElementById("content") as ReactNode}
              dataLength={swipeFileListItemsLength ?? 0}
              next={fetchMoreSwipeFileItem}
              hasMore={hasMoreData}
              loader={
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </Box>
              }
              style={{ overflow: "hidden" }}
              key={swipeFileListItemsLength}
            >
              <></>
            </InfiniteScroll>
          </ListContainer>
        )}

        {viewType === ViewTypeEnum.List &&
          finalSwipeFileList?.data?.length === 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <CircularProgress />
            </Box>
          )}

        {viewType === ViewTypeEnum.List &&
          finalSwipeFileList?.data?.length > 0 && (
            <Tablecontainer id="scrollableDiv">
              <InfiniteScroll
                scrollableTarget={
                  document.getElementById("content") as ReactNode
                }
                dataLength={swipeFileListItemsLength}
                next={fetchMoreSwipeFileItem}
                hasMore={hasMoreData}
                loader={
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                }
                style={{ overflow: "unset" }}
                key={swipeFileListItemsLength}
                // scrollableTarget="scrollableDiv"
              >
                <AdTable />
              </InfiniteScroll>
            </Tablecontainer>
          )}
      </>
    );
  }, [
    finalSwipeFileList?.data,
    finalSwipeFileList?.total,
    viewType,
    isLoading,
  ]);

  const RenderBrandsComponent = useMemo(() => {
    const swipeFileTopBrandListsLength =
      swipeFileTopBrandLists?.data?.length ?? 0;

    if (isLoading) {
      return (
        <ListContainer sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </ListContainer>
      );
    }
    if (favouriteBrandFilterEnabled && swipeFileTopBrandListsLength === 0) {
      return (
        <ListContainer>
          <HeaderTitle textAlign="center">No favoutite brands.</HeaderTitle>
        </ListContainer>
      );
    }
    if (swipeFileTopBrandListsLength === 0) {
      return (
        <ListContainer>
          <HeaderTitle textAlign="center">
            {/*Your saved Ad's brand will appear here*/}
            No brand found
          </HeaderTitle>
          <HeaderSubTitle textAlign="center">
            Use our extension to save ads from platforms and grow
          </HeaderSubTitle>
        </ListContainer>
      );
    }
    return (
      <ListContainer>
        {!favouriteBrandFilterEnabled && (
          <TopBrandCarousel
            brandsTitle="Brands of Ads You Saved the Most"
            topBrandLists={swipeFileTopBrandLists?.top10}
            handleViewAd={handleViewAdsButtonClicked}
          />
        )}
        {swipeFileTopBrandListsLength > 1 && (
          <BrandCountText>{swipeFileTopBrandListsLength} Brands</BrandCountText>
        )}
        <InfiniteScroll
          scrollableTarget={document.getElementById("content") as ReactNode}
          dataLength={swipeFileTopBrandListsLength}
          next={fetchMoreBrands}
          hasMore={swipeFileTopBrandLists?.total > swipeFileTopBrandListsLength}
          loader={
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          }
          style={{ overflow: "hidden" }}
        >
          <BrandGridContainer container spacing={1.25}>
            {swipeFileTopBrandLists?.data?.map(
              (item: brandItem, index: number) => (
                <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
                  <BrandCard
                    item={item}
                    handleViewAd={handleViewAdsButtonClicked}
                  />
                </Grid>
              )
            )}
          </BrandGridContainer>
        </InfiniteScroll>
      </ListContainer>
    );
  }, [
    swipeFileTopBrandLists?.data,
    swipeFileTopBrandLists?.total,
    favouriteBrandFilterEnabled,
    isLoading,
  ]);

  const swipeFilesSections: {
    [key: number]: JSX.Element;
  } = {
    0: <>{RenderAdsComponent}</>,
    1: <>{RenderBrandsComponent}</>,
  };

  return (
    <Container>
      <HeaderSection>
        <Header content={content} />
        {selectedTableItems.length > 1 ? (
          <TableToolbar />
        ) : (
          <>
            <SearchAndFilter
              handleFilter={fetchfilterSwipeFileItems}
              selectedBrands={selectedBrands}
              selectedPlatforms={selectedPlatforms}
              handleSortFilter={fetchSortingSwipeFileItems}
              selectedFilterOption={swipefileSelectedSortOption}
              renderBoardFilter={true}
              selectedBoards={selectedBoards}
              searchValue={searchValue}
              handleSearchChange={handleSearchChange}
              hanldeSearchButton={hanldeSearchButton}
              buttonsToShow={
                swipeFilesTabs[swipeFileTabIndex].searchAndFilterButtons
              }
              favouriteBrandFilter={{
                value: favouriteBrandFilterEnabled,
                setValue: handleSwipeFilesBrandFavouriteFilter,
              }}
              filterCounts={swipeFileFilterCounts}
              handleClearFilter={handleClearSwipeFileFilter}
              userId={userDetails?._id}
              handleKeyDown={handleSearchText}
              renderTagFilter={true}
              selectedTags={selectedTags}
            />
          </>
        )}
        <TabsHeader
          tabIndex={swipeFileTabIndex}
          data={swipeFilesTabs}
          setTabIndex={setSwipeFileTabIndex}
        />
        {activePlan?.isFreePlan && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: theme.colors.lightBlue,
              padding: "0.75rem 1rem",
              borderRadius: "8px",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="subtitle2"
              color={theme.colors.white}
              fontWeight={700}
              sx={{ flex: 1, mr: 2 }}
            >
              You are currently on the Free plan. Only 5 ads are visible.
              Upgrade your plan to see the full list.
            </Typography>

            <StyledContainedButton
              variant="contained"
              size="small"
              sx={{
                backgroundColor: theme.colors.white,
                color: theme.colors.lightBlue,
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: theme.colors.white,
                  opacity: 0.9,
                },
              }}
              onClick={() => {
                navigate(`${routeConstant.subscription}`);
              }}
            >
              Upgrade Plan
            </StyledContainedButton>
          </Box>
        )}
        {swipeFilesSections[swipeFileTabIndex]}
      </HeaderSection>
      <SaveAdPopover reFetchData={refetchSwipeFileItem} />
      <CreateBoardModal />
      <AddToBoardModal />
      <DeleteAdModal
        handleDelete={handleDelete}
        handleMultipleDelete={handleDeleteMultipleAds}
      />
      <AddTagModal />
    </Container>
  );
};

export default SwipeFiles;
